/**
 * @Author:
 * @Description: AI 助手接口
 * @DateTime: Created in 10:55 2026/8/27
 */
import Api from 'src/util/api';

export interface ChatParamsI {
	message: string;
	sessionId?: string | number;
}

export interface ChatResultI {
	sessionId?: string | number;
	answer: string;
}

export default class AiAssistantApi {
	/**
	 * AI 对话
	 * @param params
	 * @returns {Promise<any>}
	 */
	static async chat(params: ChatParamsI): Promise<any> {
		return Api.post('/ai_assistant/chat', params);
	}
}
